import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { Helmet } from 'react-helmet';
import Section from '../../components/Layout/Section/Section';
import InnerContainer from '../../components/Layout/InnerContainer/InnerContainer';
import Main from "../../components/Layout/Main";
import CoverImage from "../../components/CoverImage";
import Star from '../../components/Dividers/star';
import Wave from '../../components/Dividers/wave';
import LargeEditorial from '../../components/LargeEditorial'
import PhotoGrid from '../../components/PhotoGrid';
import Wave3 from '../../components/Dividers/wave3';
import ThreeStar from '../../components/Dividers/ThreeStar'

import './talent.scss';

const Talent = () => {
  const { markdownRemark } = useStaticQuery(graphql`
    query TalentQuery {
      markdownRemark(frontmatter: { pageId: { eq: "talent-page" } }) {
        frontmatter {
          components {
            type
            headline
            body {
              line
            }
            attr
            quotes {
              quote
              source
            }
            image {
              childImageSharp {
                fluid(maxWidth: 2048, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
              extension
              publicURL
            }
            gridImages {
              featured
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
            }
            blocks {
              body
              headline
              bullets {
                bullet
              }
            }
          }
        }
      }
    }
  `)

  function getComponent(name) {
    const components = markdownRemark.frontmatter.components;
    return components.filter(component => component.type === name)[0];
  }

  const CoverImageContent = getComponent("coverImage");
  const CoverImage2Content = getComponent("coverImage2");
  const CoverImage3Content = getComponent("coverImage3");
  const PullQuote1Content = getComponent("pullQuoteSmall1");
  const PullQuote2Content = getComponent("pullQuoteSmall2");
  const largeEditorialContent = getComponent("largeEditorial")
  const largeEditorial2Content = getComponent("largeEditorial2")
  const photoGridContent = getComponent("photoGrid").gridImages;
  const photoGrid2Content = getComponent("photoGrid2").gridImages;
  const HostsGridContent = getComponent("hostsGrid").gridImages;

  return (
    <Main>
      <Helmet>
        <body className="talent-page" />
      </Helmet>
      <CoverImage
        image={CoverImageContent.image}
        headline={CoverImageContent.headline}
        hero="hero"
      />
      <Section customClass={["color-block", "bg-yellow"]}>
        <InnerContainer customClass="pull-quote">
          <Star customClass="star--top"/>
          <h3 className="pull-quote__body large">{PullQuote1Content.body[0].line}</h3>
          <p className="pull-quote__body">{PullQuote1Content.body[1].line}</p>
          <Star customClass="star--bottom"/>
        </InnerContainer>
      </Section>
      <Section customClass={["color-block"]}>
        <Wave position="wave--relative"/>
      </Section>
      <Section customClass={["color-block", "bg-pink"]}>
        <InnerContainer customClass="pull-quote">
          <Star customClass="star--top"/>
          <h3 className="pull-quote__body large">{PullQuote2Content.body[0].line}</h3>
          <p className="pull-quote__body">{PullQuote2Content.body[1].line}</p>
          <Star customClass="star--bottom"/>
        </InnerContainer>
      </Section>
      <CoverImage
        image={CoverImage2Content.image}
        headline={CoverImage2Content.headline}
        variant="singleFrame"
      />
      <LargeEditorial
        image={largeEditorialContent.image}
        blocks={largeEditorialContent.blocks}
      />
      <Section>
        <InnerContainer customClass="text-block">
          <ThreeStar/>
          <PhotoGrid gridImages={HostsGridContent} />
          <p className="text-block__body">VMA Pre-Show Hosts: Travis Mills, Nessa, Jamila Mustafa, & Kevan Kenney.</p>
        </InnerContainer>
      </Section>
      <Section>
        <Wave3/>
      </Section>
      <PhotoGrid gridImages={photoGridContent} />
      <CoverImage
        image={CoverImage3Content.image}
        headline={CoverImage3Content.headline}
      />
      <LargeEditorial
        image={largeEditorial2Content.image}
        blocks={largeEditorial2Content.blocks}
      />
      <Section><ThreeStar/></Section>
      <PhotoGrid gridImages={photoGrid2Content} />
    </Main>
  );
}

export default Talent
